import { render, staticRenderFns } from "./AdvertComp.vue?vue&type=template&id=0ea57769&scoped=true"
import script from "./AdvertComp.vue?vue&type=script&lang=js"
export * from "./AdvertComp.vue?vue&type=script&lang=js"
import style0 from "./AdvertComp.vue?vue&type=style&index=0&id=0ea57769&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea57769",
  null
  
)

export default component.exports